const MAX_PER_REQUEST = 5;
/** Split array into chunks */ const chunk = (arr, size)=>{
    const out = [];
    for(let i = 0; i < arr.length; i += size)out.push(arr.slice(i, i + size));
    return out;
};
/** Replace #shopify-section-<id> with returned HTML */ const replaceSectionHtml = (scope, id, html)=>{
    if (!html) return false // null means render failed
    ;
    const temp = document.createElement('div');
    temp.innerHTML = html;
    var _temp_querySelector;
    const fresh = (_temp_querySelector = temp.querySelector(`#shopify-section-${CSS.escape(id)}`)) !== null && _temp_querySelector !== void 0 ? _temp_querySelector : temp.firstElementChild;
    const current = scope.querySelector(`#shopify-section-${CSS.escape(id)}`);
    if (fresh && current) {
        current.replaceWith(fresh);
        return true;
    }
    return false;
};
/**
 * Reload one or many sections via Shopify’s Section Rendering API.
 * Returns a map of { id: true/false } indicating success.
 */ export const reloadSections = async (sectionIds, options = {})=>{
    var _Shopify_routes, _options_onAfterReplace;
    var _options_scope;
    const scope = (_options_scope = options.scope) !== null && _options_scope !== void 0 ? _options_scope : document;
    var _options_context;
    const context = (_options_context = options.context) !== null && _options_context !== void 0 ? _options_context : 'current';
    const base = context === 'root' ? (Shopify === null || Shopify === void 0 ? void 0 : (_Shopify_routes = Shopify.routes) === null || _Shopify_routes === void 0 ? void 0 : _Shopify_routes.root) || '/' : window.location.pathname;
    const results = Object.create(null);
    if (!sectionIds.length) return results;
    // Optional: use ?section_id= for single section (HTML response)
    if (options.useSingleParamWhenOne && sectionIds.length === 1) {
        var _options_onAfterReplace1;
        const id = sectionIds[0];
        if (!id) return results;
        const res = await fetch(`${base}?section_id=${encodeURIComponent(id)}`, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            signal: options.signal
        });
        if (!res.ok) {
            results[id] = false;
        } else {
            const html = await res.text();
            results[id] = replaceSectionHtml(scope, id, html);
        }
        (_options_onAfterReplace1 = options.onAfterReplace) === null || _options_onAfterReplace1 === void 0 ? void 0 : _options_onAfterReplace1.call(options);
        return results;
    }
    // Use ?sections= (JSON response, up to 5 per request)
    const groups = chunk(sectionIds, MAX_PER_REQUEST);
    for (const ids of groups){
        const url = `${base}?sections=${encodeURIComponent(ids.join(','))}`;
        const res = await fetch(url, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            signal: options.signal
        });
        if (!res.ok) {
            ids.forEach((id)=>results[id] = false);
            continue;
        }
        const json = await res.json();
        ids.forEach((id)=>{
            var _json_id;
            const ok = replaceSectionHtml(scope, id, (_json_id = json[id]) !== null && _json_id !== void 0 ? _json_id : null);
            results[id] = ok;
        });
    }
    (_options_onAfterReplace = options.onAfterReplace) === null || _options_onAfterReplace === void 0 ? void 0 : _options_onAfterReplace.call(options);
    return results;
};
